import { useState } from "react";
import { Link } from "react-router-dom";

const API_BASE_URL = "https://bluewaterdubai.websiteseoonline.com";

const initialForm = {
  name: "",
  phone: "",
  email: "",
  subject: "",
  message: "",
};

function buildApiUrl(pathname) {
  const baseUrl = (process.env.REACT_APP_API_BASE_URL || API_BASE_URL).replace(/\/$/, "");
  return baseUrl + pathname;
}

function ContactUs() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("idle");
  const [feedback, setFeedback] = useState("");

  function updateField(fieldName, value) {
    setForm((current) => ({
      ...current,
      [fieldName]: value,
    }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setStatus("sending");
    setFeedback("");

    const payload = {
      agent_name: form.name,
      agent_lname: "",
      agent_phone: form.phone,
      agent_email: form.email,
      agent_subject: form.subject,
      agent_address: form.message,
      current_url: window.location.href,
    };

    try {
      const response = await fetch(buildApiUrl("/api/EnquiryHandlerStatic.ashx"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Unable to send message");
      }

      const responseText = await response.text();
      const result = responseText ? JSON.parse(responseText) : { status: "success" };

      if (result.status !== "success") {
        throw new Error(result.message || "Unable to send message");
      }

      setForm(initialForm);
      setStatus("success");
      setFeedback(result.message || "Message sent successfully");
    } catch (err) {
      setStatus("error");
      setFeedback(err.message || "Unable to send message");
    }
  }

  return (
    <>
      <div className="breadcumb-wrapper" style={{ backgroundImage: "url('/assets/img/tgerfr.jpg')" }}>
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title"> Let's start a conversation</h1>
            <ul className="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="contact-area-2 space-top" id="contact-sec">
        <div className="container">
          <div className="row gy-4 justify-content-center">
            <div className="col-xl-4 col-lg-6 contact-feature-wrap">
              <div className="contact-feature">
                <div className="contact-feature-icon">
                  <i className="fas fa-location-dot" />
                </div>
                <div className="media-body">
                  <p className="contact-feature_label">Office Address</p>
                  <span className="contact-feature_link">
                    P.O. Box 9638
                    <br />
                    Office 113, MSM 1 Building
                    <br />
                    127 22D Street, Al Safa 1,
                    <br />
                    Dubai, U.A.E.
                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 contact-feature-wrap">
              <div className="contact-feature">
                <div className="contact-feature-icon">
                  <i className="fas fa-phone" />
                </div>
                <div className="media-body">
                  <p className="contact-feature_label">Phone Number</p>
                  <a href="tel:+97144514747" className="contact-feature_link">
                    +971 4 4514747
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 contact-feature-wrap">
              <div className="contact-feature">
                <div className="contact-feature-icon">
                  <i className="fas fa-envelope" />
                </div>
                <div className="media-body">
                  <p className="contact-feature_label">Email Address</p>
                  <a href="mailto:info@bluewaterdubai.com" className="contact-feature_link">
                    info@bluewaterdubai.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-form-area">
        <div className="container">
          <div className="row gx-0">
            <div className="col-xl-12">
              <div className="contact-all-wrapper">
                <div className="contact-form-wrap">
                  <form className="contact-form" onSubmit={handleSubmit}>
                    <h3 className="form-title">Do you have questions? Contact Us</h3>
                    <div className="row">
                      <div className="form-group col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          value={form.name}
                          onChange={(event) => updateField("name", event.target.value)}
                          placeholder="Name *"
                          required
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <input
                          type="tel"
                          className="form-control"
                          value={form.phone}
                          onChange={(event) => updateField("phone", event.target.value)}
                          placeholder="Phone *"
                          required
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <input
                          type="email"
                          className="form-control"
                          value={form.email}
                          onChange={(event) => updateField("email", event.target.value)}
                          placeholder="Email Address *"
                          required
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <select className="form-select" value={form.subject} onChange={(event) => updateField("subject", event.target.value)}>
                          <option value="">Select Subject</option>
                          <option value="Apartment">Apartment</option>
                          <option value="House">House</option>
                          <option value="Villa">Villa</option>
                          <option value="Land">Land</option>
                        </select>
                      </div>
                      <div className="form-group col-12">
                        <textarea
                          value={form.message}
                          onChange={(event) => updateField("message", event.target.value)}
                          cols="30"
                          rows="3"
                          className="form-control"
                          placeholder="Your Message *"
                          required
                        />
                      </div>
                      <div className="form-btn text-start col-12">
                        <button className="th-btn radius" type="submit" disabled={status === "sending"}>
                          {status === "sending" ? "Sending..." : "Send message"}
                        </button>
                      </div>
                    </div>
                    {feedback ? <p className={`form-messages property-enquiry-feedback ${status === "error" ? "error" : "success"}`}>{feedback}</p> : null}
                  </form>
                </div>
                <div className="contact-form-thumb overflow-hidden">
                  <img src="/assets/img/contact/contact-page-thumb.jpg" alt="Contact Blue Water Real Estate" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3611.0855367559802!2d55.233000875380725!3d25.16658947773065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sP.O.%20Box%209638%0D%0AOffice%20113%2C%20MSM%201%20Building%0D%0A127%2022D%20Street%2C%20Al%20Safa%201%2C%0D%0ADubai%2C%20U.A.E.!5e0!3m2!1sen!2sae!4v1780562480410!5m2!1sen!2sae"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        title="Blue Water Real Estate location map"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </>
  );
}

export default ContactUs;
